import { Typography } from '../Typography';
import styles from './DrivingInnovation.module.scss';

const DrivingInnovation = () => {
  return (
    <div className={styles.pageWrapper}>
      <section className={styles.drivingInnovationSection}>
        <div className={styles.drivingInnovationContent}>
          <div className={styles.drivingInnovationText}>
            <Typography variant="display-lg" as="h2" color="primary">
              Driving Innovation with Precision and Purpose
            </Typography>

            <Typography variant="text-xl" color="grayDark-400">
              Design, compile, and deploy professional video processing plugins across all major
              editing platforms with a single visual workflow.
            </Typography>
          </div>
        </div>

        <div className={styles.imageGallery}>
          <img
            src="/product-drivingInnovation.svg"
            alt="VxFX Framework Driving Innovation in Video Plugin Development - Visual Workflow Design"
          />
        </div>
      </section>
    </div>
  );
};

export default DrivingInnovation;
